import React from "react";
import { useParams } from "react-router-dom";
import { Styled } from "./styles";
import withErrorBoundary from "@/components/hoc/withErrorBoundary";
import Organizations from "@/components/settings/organizations";
import Notifications from "@/components/settings/notifications";
import { Params } from "@/types/utils";

const Settings: React.FC = () => {
    const { oid } = useParams<Params>();

    return (
        <Styled.Page>
            <Organizations />
            {/* Keyed so that switching organization discards unsaved recipients
                instead of carrying them over to the next organization. */}
            <Notifications key={oid} />
        </Styled.Page>
    );
};

export default withErrorBoundary({ component: "Settings" })(Settings);
